import type { FlowNode } from "../api.ts";

// Tiles use the same colours as the matching canvas blocks
// (Block.tsx PALETTE) so the toolbox doubles as a legend.
const KINDS: {
  kind: FlowNode["kind"];
  icon: string;
  label: string;
  hint: string;
  bg: string;
  fg: string;
}[] = [
  { kind: "play", icon: "▶", label: "Diffuser", hint: "Joue une annonce à l'appelant", bg: "#dbeafe", fg: "#0c4a6e" },
  { kind: "collect", icon: "🔢", label: "Demander un numéro", hint: "L'appelant saisit un numéro (ex. affaire) au clavier", bg: "#fef3c7", fg: "#78350f" },
  { kind: "menu", icon: "☰", label: "Menu DTMF", hint: "Oriente selon la touche pressée", bg: "#fde68a", fg: "#78350f" },
  { kind: "ring", icon: "🔔", label: "Sonner les agents", hint: "Sonne les agents disponibles l'un après l'autre", bg: "#bfdbfe", fg: "#1e3a8a" },
  { kind: "voicemail", icon: "📥", label: "Répondeur", hint: "Annonce puis enregistrement d'un message", bg: "#fecaca", fg: "#7f1d1d" },
  { kind: "hangup", icon: "⏹", label: "Raccrocher", hint: "Termine l'appel proprement", bg: "#e2e8f0", fg: "#0f172a" },
];

export function Palette(props: { onAdd: (kind: FlowNode["kind"]) => void; busy: boolean }) {
  return (
    <div className="flow-toolbox">
      <span className="flow-toolbox__title">🧰 Boîte à outils</span>
      <div className="flow-toolbox__tiles">
        {KINDS.map((k) => (
          <button
            key={k.kind}
            type="button"
            className="flow-toolbox__tile"
            style={{ background: k.bg, color: k.fg }}
            disabled={props.busy}
            title={`${k.hint} — cliquez pour ajouter ce bloc au flux`}
            onClick={() => props.onAdd(k.kind)}
          >
            <span aria-hidden="true">{k.icon}</span>
            {k.label}
            <span className="flow-toolbox__plus" aria-hidden="true">＋</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export function blankNode(kind: FlowNode["kind"]): FlowNode {
  switch (kind) {
    case "start":
      return { kind: "start", next: "" };
    case "play":
      return { kind: "play", greetingId: null, next: "" };
    case "collect":
      return { kind: "collect", greetingId: null, min: 4, max: 10, attachToCallerId: true, next: "" };
    case "menu":
      return { kind: "menu", greetingId: null, branches: { "1": "", "2": "" }, onTimeout: "", onInvalid: "", timeoutSec: 5 };
    case "ring":
      return { kind: "ring", timeoutSec: 6, onAnswer: "", onNoAnswer: "", onNoOneOnline: "" };
    case "voicemail":
      return { kind: "voicemail", greetingId: null, silent: false };
    case "hangup":
      return { kind: "hangup" };
  }
}
